<h2 mat-dialog-title>Alterar Largura Tabela</h2>

<mat-dialog-content fxLayout="column">
    <div style="padding-bottom: 0.5rem">
        <div fxLayout="row" fxLayoutAlign="center" style="margin-top: 10px; margin-bottom: 10px;">
            <div style="display: flex; justify-content: center;">
                <table [style.width]="larguraTotal+'px'">
                    <tr>
                        <th *ngFor="let coluna of conteudo.colunas" class="th_coluna_{{pinRandom}}_{{coluna.posicao}}"
                            [style.text-align]="coluna.alinhamento === 'L' ? 'left' : coluna.alinhamento === 'C' ? 'center' : 'right'"
                            [style.width]="coluna.largura+'px'" [style.padding-left]="'0px'" [style.padding-right]="'0px'">
                            <div class="resizer" id="coluna_{{pinRandom}}_{{coluna.posicao}}"
                                 (mousedown)="onMouseDownResizer($event)"></div>
                            <div class="descricaoColuna">
                                {{ coluna.descricao }}
                            </div>
                        </th>
                    </tr>
                </table>
            </div>
        </div>
        <div fxLayout="row" style="margin-top: 10px; margin-bottom: 10px;">
            <mat-checkbox color="primary"
                          title="Largua Total Fixa"
                          name="larguraTotalFixa"
                          [(ngModel)]="larguraTotalFixa"
                          style="margin-top: 15px; margin-left: 15px;">
                Largua Total Fixa
            </mat-checkbox>
            <mat-form-field fxFlex="100" fxFlexOffset="20px">
                <input matInput type="number" [ngModelOptions]="{standalone: true}"
                       name="larguraColuna__{{pinRandom}}"
                       [(ngModel)]="larguraTotal" pattern="[0-9]+$" placeholder="Largura Total"
                       required (change)="onChageLarguraColuna()">
            </mat-form-field>
        </div>

    </div>
</mat-dialog-content>

<mat-dialog-actions fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="16px">
    <button mat-button (click)="voltar()">Voltar</button>
</mat-dialog-actions>